export default __webpack_public_path__ + "static/media/blog-img159.9656e37d.jpg";